'use strict';//Indicating browser should run only in java script mode
(function () {

    angular.module('EMR.SelectStatusOfInhouseOrders', []);

    var SelectStatusOfInhouseOrdersModuleRoutes = [
        {
            name: "SelectStatusOfInhouseOrders",
            templateUrl: "<div emr-labs-ordered-inhouse-select-status-popup></div>",
            RoutingNumber: 1926,
            files: [
                "AngularScripts/SelectStatusOfInhouseOrders/Services/SelectStatusOfInhouseOrdersService.js",
                "AngularScripts/SelectStatusOfInhouseOrders/Directives/LabsOrderedInhouseSelectStatusPopupDirective.js"
            ],
        },

    ]

    angular.module('EMR.SelectStatusOfInhouseOrders')
        .config(["$stateProvider", "EmrRouteProvider",
            function ($stateProvider, EmrRouteProvider) {
                EmrRouteProvider.registerStates(SelectStatusOfInhouseOrdersModuleRoutes, $stateProvider);
            }]);
})();